import React, { createContext, useContext, useState } from "react";

interface StudentSidebarContextType {
  isCollapsed: boolean;
  toggleSidebar: () => void;
}

const StudentSidebarContext = createContext<StudentSidebarContextType | undefined>(undefined);

export const StudentSidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleSidebar = () => setIsCollapsed((prev) => !prev);

  return (
    <StudentSidebarContext.Provider value={{ isCollapsed, toggleSidebar }}>
      {children}
    </StudentSidebarContext.Provider>
  );
};

export const useStudentSidebar = () => {
  const ctx = useContext(StudentSidebarContext);
  if (!ctx) throw new Error("useStudentSidebar must be used within a StudentSidebarProvider");
  return ctx;
};

export const SIDEBAR_EXPANDED_WIDTH = 215;
export const SIDEBAR_COLLAPSED_WIDTH = 60;